import React from 'react'
import { useRouter } from 'next/router'
import { IModuleApi } from 'src/service/api/api.types'
import { calcProgressModule } from 'src/utils/calcProgress'
import ModuleItem from 'src/components/Common/MenuModules/components/ModuleList/Module'
import {MenuModulesSkeleton} from "src/components/Skeleton/menuModules";
import {useSelector} from "react-redux";
import {State} from "src/store/rootReducers";
import { Nav } from './styles'

interface Props {
  id?: string
  modules: IModuleApi[]
}

function MenuList({ id, modules }: Props) {
  const router = useRouter()
  const isLoading = useSelector((state: State) => state.course.isLoading)
  const progress = React.useCallback(
    (module: IModuleApi) => calcProgressModule(module.lessons),
    [module],
  )

  return (
    <Nav>
      <ul id={id}>
        {isLoading ? <MenuModulesSkeleton /> : modules.map((module, index) => (
            <li key={`${module.id}`} className={router.pathname === '/' ? 'active' : ''}>
              <ModuleItem module={module} identify={index} progress={progress(module)} />
            </li>
          ))}
      </ul>
    </Nav>
  )
}

export default MenuList
